<template>
  <div class="jobApply">
    <div class="wrap">
      <div class="page_tit">
        <h3>{{ $t('joblist.zhaopinxinxi') }}</h3>
      </div>
      <div class="pro_list">
        <el-form :rules="rules" :model="jdescrible" ref="jdescrible" label-width="100px" class="ruleForm" size="mini">
          <el-row>
            <div class="divLine"><i class="el-icon-document"></i>{{ $t('joblist.jobdes') }}</div>
          </el-row>
          <el-row>
            <el-col class="flex">
              <h4>{{ $t('joblist.jobname') }}：</h4>  
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
              {{ jdescrible.jobname }} 
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.jobname">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.location">{{ $t('joblist.joblocation') }}：</h4>  
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
               {{ jdescrible.location }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.location">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.num">{{ $t('joblist.jobnum') }}：</h4> 
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
               {{ jdescrible.num }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.num">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.experience">{{ $t('joblist.jobexprence') }}：</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
                {{ jdescrible.experience }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.experience">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.education">{{ $t('joblist.jobxueli') }}：</h4> 
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
              {{ jdescrible.education }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.education">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.hangye">{{ $t('joblist.jobhangye') }}：</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
                {{ jdescrible.hangye }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.hangye">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.guimo">{{ $t('joblist.jobguimo') }}：</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
                {{ jdescrible.guimo }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.guimo">
          <el-row>
            <el-col class="flex">
              <h4 v-if="jdescrible.xingzhi">{{ $t('joblist.jobxingzhi') }}：</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex">
                {{ jdescrible.xingzhi }}
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.xingzhi">
          <el-row>
            <el-col class="flex">
              <h4>{{ $t('joblist.jobsalary') }}：</h4> 
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex"> 
              <div v-if="this.jdescrible.salary!='面议'"></div>
              <div v-html="this.jdescrible.salary"></div>
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.salary">
          <el-row>
            <el-col class="flex">
              <h4>{{ $t('joblist.jobdescription') }}：</h4> 
            </el-col>
          </el-row>
          <el-row>
            <el-col class="flex"> 
              <div class="flex1" v-html="this.jdescrible.jobinfo"></div>
            </el-col>
          </el-row>
          <br v-if="this.jdescrible.jobinfo">
          <el-row style="padding-top: 40px;">
            <el-col>
              <h4> </h4>
            </el-col>
          </el-row>
          <div class="ht20"></div>
          <el-row>
            <div class="divLine"><i class="el-icon-document"></i> {{ $t('joblist.application') }}</div>
          </el-row>
<div class="text">
          <div class="text_pos">
            <h5>WE ARE HERE TO HELP</h5>
            <p>Our sophisticated customer support will reply asap. Do NOT hesitate to send us the email or leave a message to contact us. <br> We want YOU to get the job!</p>
          </div>
        </div>
          <el-form-item class="flex flex-inputs" prop="name" :gutter="20" style="padding-top: 10px;">
            <el-input v-model="jdescrible.name" :placeholder="$t('joblist.name')"></el-input>
          </el-form-item>
          <el-form-item class="flex flex-inputs" prop="lastname" :gutter="20" style="padding-top: 10px;">
            <el-input v-model="jdescrible.lastname" :placeholder="$t('joblist.lastname')"></el-input>
          </el-form-item>
          <el-form-item class="flex flex-inputs" prop="phone" :gutter="20">
            <el-col>
              <el-input  v-model="jdescrible.phone" :placeholder="$t('joblist.phone')"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item class="flex flex-inputs" prop="email" :gutter="20">
            <el-col>
              <el-input v-model="jdescrible.email" :placeholder="$t('joblist.email')"></el-input>
            </el-col>
          </el-form-item> 
          <div class="ht20">
          </div> 
          <el-form-item :gutter="20">
            <el-col>
              <el-input type="textarea" :rows="5" :placeholder="$t('joblist.message')" v-model="jdescrible.remark">
              </el-input>
            </el-col>
          </el-form-item>
          <el-row>
            <div class="Thisform">
              <el-form ref="form" :model="form" label-width="">
                <el-form-item :label="$t('joblist.attachment')"> 
                  <el-upload ref="upload" action="#" :limit="1" accept=".xls,.xlsx,.doc,.docx,.pdf" :on-change="handleChange"
                               :on-remove="handleRemove" :on-exceed="handleExceed" :file-list="fileList" :http-request="uploadFile"
                              :auto-upload="false">
                                 <el-button slot="trigger" type="primary" size="small" align="right">{{ $t('joblist.selectfile') }}</el-button>
                                 <!-- <el-button type="success" style="margin-left: 100px;" size="small" @click="submitUpload">上传到服务器</el-button> -->
                                 <div slot="tip" class="el-upload__tip">{{ $t('joblist.description') }}</div>
                             </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </el-row>
          <!-- <slide-verify 
     ref="slideblock"
      @again="onAgain"
      @fulfilled="onFulfilled"
      @success="onSuccess"
      @fail="onFail"
      @refresh="onRefresh"
      :accuracy="accuracy"
      :slider-text="text"></slide-verify> -->
          <div>{{msg}}</div> 
          <div class="ht20"></div> 
          <el-button type="primary" @click="onSubmitForm">{{ $t('joblist.apply') }}</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueRouter from "vue-router";


const router = new VueRouter({});
export default {
  data() {
    return {
      isValuate:1,
      msg: '',
      text: '向右滑',
      // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      accuracy: 1,
      fileData: '', // 文件上传数据（多文件合一）
      fileList: [], // upload多文件数组
      storageFileName: "1",
      file: '',
      keyword: "kevinq",
      form: {},
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      jdescrible: {
        id: 0,
        jobname: "",
        location: "",
        num: "",
        experience: "",
        education: "",
        hangye: "",
        guimo: "",
        xingzhi: "",
        salary: "",
        jobinfo: 0,
        create_time: "",
        name: "",
        lastname:"",
        phone: "",
        email: "",
        remark: "",
        filename: "",
      },
      rules: {
        name: [
          { required: true, message: this.$t('joblist.inputname'), trigger: 'blur' }
        ],
        lastname: [
          { required: true, message: this.$t('joblist.inputlastname'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('joblist.inputphone'), trigger: 'blur' }
        ],
        email: [
          { type: 'email', required: true, message: this.$t('joblist.inputemail'), trigger: 'blur' }
        ],
      }
    };
  },
  components: {},
  created() {
    console.log('11111'+this.$i18n.locale)
    console.log(this.$route.query.lang);
    this.$i18n.locale = this.$route.query.lang; 
    if (this.$route.query.lang=='en')
            {
              document.getElementById("langzh").setAttribute("class","");
              document.getElementById("langen").setAttribute("class","active");
            }
            else
            {
              document.getElementById("langzh").setAttribute("class","active");
              document.getElementById("langen").setAttribute("class","");
            }
    this.loading = false;
    this.handleQuery();
  },
  methods: {
    onSuccess(times){ 
            this.msg = '验证成功';
            this.isValuate = 2;
        },
        onFail(){
            console.log('验证不通过');
            this.msg = '请重新尝试'
        },
        onRefresh(){
            console.log('点击了刷新小图标');
            this.isValuate = 1;
            this.msg = ''
        },
        onFulfilled() {
            console.log('刷新成功啦！');
            this.isValuate = 1;
        },
        onAgain() {
            console.log('检测到非人为操作的哦！');
            this.msg = 'try again';
            // 刷新
            this.$refs.slideblock.reset();
        },
        handleClick() {
        	// 父组件直接可以调用刷新方法
            this.$refs.slideblock.reset();
        },
            // 导入exel
            async importExcel() {
                this.isEditWinShow = true;
            },
            // 上传文件
            uploadFile(file) {
                this.fileData.append('files', file.file);
            },
            submitUpload() {
              console.log(this.fileList.length)
                const loading = this.$loading({
                    lock: true,
                    text: '数据提取中，请稍后',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (this.fileList.length === 0) {
                    this.$message({
                        message: '请上传简历',
                        type: 'warning'
                    });
                } else{
                    const isLt700K = this.fileList.every(file => file.size / 1024 / 1024 / 1024 < 700);
                    if (!isLt700K) {
                        this.$message.error('请检查，上传文件大小不能超过700KB!');
                    } else {
                        var formData = new FormData(); //  用FormData存放上传文件
                        this.fileList.forEach(file => {
                            formData.append('partsInfoFile', file.raw, file.raw.name);
                        })                           //向webapi发起请求，等待后台接收
                        axios.post(   'https://test2.uc-elink.co.uk/api/content/UploadPartsInfo', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                            .then((response) => {
                                    if (response.status == "200") {
                                        setTimeout(() => {
                                            loading.close(); 
                                            this.storageFileName = response.data; 
                                         //    this.fileList = [];
                                         //    this.fileData = "";
                                          //  this.isEditWinShow = false;
                                         //   this.isLoading = false;
                                        }, 1000);
                                    } else {
                                        this.$message({
                                            type: 'error',
                                            message: '导入失败，请联系管理员'
                                        });
                                        this.isLoading = false;
                                    }
                                },
                                error => {
                                    loading.close();
                                    this.$message.error('系统异常，请稍后再试');
                                    return Promise.reject(error);
                                }
                            )
                    }
                }
            },
            //移除
            handleRemove(file, fileList) {
                this.fileList = fileList;
            },
            // 选取文件超过数量提示
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            //监控上传文件列表
            handleChange(file, fileList) { 

                let existFile = fileList.slice(0, fileList.length - 1).find(f => f.name === file.name);
                if (existFile) {
                    this.$message.error('当前文件已经存在!');
                    fileList.pop();
                }
                this.fileList = fileList;
                this.submitUpload();
            },
    // 查询按钮——显示数据
    handleQuery() {
      console.log(router);
      
      let a = this.$route.query.id;
      console.log(a);
      this.listLoading = true;
      let param = {
        id : a,
        language: this.$i18n.locale,
      };
      this.$http
        .post( 
    //    "http://localhost:6879/api/Content/GetCasesById/",
          "https://test2.uc-elink.co.uk/api/Content/GetCasesById",
          param,
          {
            "Content-Type": "application/json;charset=UTF-8",
          }
        )
        .then((response) => {
          var text = response.data.replace(/[\r|\n|\t]/g, "");
          var list = JSON.parse(text);
          this.jdescrible = list[0];
          console.log(this.jdescrible);
        });
    },
    onSubmitFile(event) {
      console.log("0000000000"); 
      this.file = event.target.files[0];
      console.log(this.file);
      let that = this;
      event.preventDefault(); //取消默认行为
      //创建 formData 对象
      let param = new FormData();
      param.append("file", this.file);
      let filename = this.file.name;
      let extName = filename.substring(filename.lastIndexOf(".")).toLowerCase();
      let ALLUpExt = ".doc|.docx|.pdf|";
      if (ALLUpExt.indexOf(extName + "|") == "-1") {
        this.$message.error("文件格式不正确！");
        return false;
      } else {
        // 提交文件 
        this.$http 
          .post( "https://test2.uc-elink.co.uk/api/Content/GetImage", param, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log("11333");
            console.log(response);
            console.log(response.data);
            this.storageFileName = response.data;
            console.log(1111111);
            console.log(this.storageFileName);
          });
      }
    },

    onSubmitForm() {
      console.log('start submit');
      // if ( this.isValuate ==1)
      // {
      //    this.msg = '请完成验证';
      //    console.log('333333333');
      //    return;
      // }
      console.log(this.storageFileName); 
      this.$refs.jdescrible.validate((valid) => {
        console.log(valid);
        if (valid && this.storageFileName != '1') {
 
          // 提交表单
          let paramBody = new FormData();
          paramBody = {
            contentId: this.$route.query.id,
            name: this.jdescrible.name,
            lastname: this.jdescrible.lastname,
            phone: this.jdescrible.phone,
            email: this.jdescrible.email,
            remark: this.jdescrible.remark,
            filename: this.storageFileName,
            storageFileName: this.storageFileName,
          };
          this.$http
            .post(
              "https://test2.uc-elink.co.uk/api/Content/submitApply",
              paramBody,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                },
              }
            )
            .then((response) => {
              console.log(response);
              this.$router.push('/success')
              this.fileList = [];
              this.fileData = "";
            });

            this.$http.post(
              'https://test3.uc-elink.co.uk/api/ucjobapply/SendJobMail',
              paramBody,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                },
              }
            )
            .then((response) => {
              console.log(response);
              this.$router.push('/success')
              this.fileList = [];
              this.fileData = "";
            });
        } else {
          // if (this.storageFileName == '1') {
          //   this.$message.error("请上传简历");
          // } 
          console.log('error submit!!');
        }
      });
    },
    getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
  },
};
</script>

<style lang="scss" scoped></style>
